import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import css from './styles.module.scss';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { getUserProfileData } from '~/features/dashboard/store/selectors';
import { getUserProfile } from '~/features/dashboard/store/actions.thunks';
import classNames from 'classnames';
import { Avatar, createStyles, Grid, IconButton, ListItem, ListItemText, makeStyles, Paper, Popover, Theme, Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import { ProfileInput } from '../profile-input';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { AddContactFormNames } from '~/store/user/models';
import { axiosInstance } from '~/api/config/axios.config';
import { UserProfile } from '~/models/profile/UserProfile.dto';
import Button from '@material-ui/core/Button';
import PhoneInput from 'react-phone-input-2';
import { Loader } from '~/common/loader';
import { pluck } from 'underscore';
import { AutocompleteRenderInputParams } from '@material-ui/lab';
import { TextFieldOutlined } from '~/common/text-field-outlined';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import { notifyError } from '~/common/notifications';


interface ContentProps {
    user: any;
    tab: number;
    changeData: any;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none',
        },
        popoverContent: {
            pointerEvents: 'auto',
        },
        root: {
            width: '100%',
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper,
        },
        large: {
            width: theme.spacing(20),
            height: theme.spacing(20),
            margin: 'auto',
        },
    })
);

export const ProfileGeneral: React.FC<ContentProps> = ({ user, tab, changeData }) => {

    const classes = useStyles();
    const dispatch = useThunkDispatch();

    const [isEditForm, setIsEditForm] = useState(false);
    const [imageFile, setImageFile] = useState<any>();
    const [userProfile, setUserProfile] = useState(new UserProfile());
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    // const [countryCode, setCountryCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [currencyCodes, setCurrencyCodes] = useState<any>([]);
    const [passwordNew, setPasswordNew] = useState('');
    const [passwordOld, setPasswordOld] = useState('');
    let dealAdvance: any = ['USD'];

    if (currencyCodes) {
        dealAdvance = pluck(currencyCodes, 'code');
        dealAdvance = dealAdvance.filter(function (element: any) {
            return element !== undefined;
        });
    }

    const isEmptyObject = (obj: any) => {
        return obj === null || obj === undefined || Object.keys(obj).length === 0;
    };


    const userProfileResponse = useSelector(getUserProfileData);

    useEffect(() => {
        axiosInstance.get('Catalogue/projectReference/currencies/list').then(({data: { data }}) => {
            setCurrencyCodes(data);
        });

        dispatch(getUserProfile());
    }, [dispatch]);

    useEffect(() => {
        if(userProfileResponse){
            changeData({
                image: userProfileResponse.image,
                firstName: userProfileResponse.firstName,
                lastName: userProfileResponse.lastName,
                email: userProfileResponse.email
            })

            let address = {}
            if(userProfileResponse.address){
                address = JSON.parse(userProfileResponse.address);
            }

            if (!isEmptyObject(address)) {
                setUserProfile({ ...userProfileResponse, ...address });
            }
            else {
                setUserProfile(userProfileResponse);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfileResponse]);

    const elementFocus = (ref: any) => {
        if (ref) {
            ref.current.focus();
        }
    };

    const updateData = (name: string, value: any) => {
        if (name) {
            setUserProfile({ ...userProfile, [name]: value });
        }
    };

    const open = Boolean(anchorEl);
    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const editContactForm = () => {
        setIsEditForm(true);
    };

    const submitForm = () => {
        setIsEditForm(false);
        if(imageFile){
            setIsLoading(true)
            const formData = new FormData();
            formData.append('file', imageFile);
            axiosInstance
                .post('/catalogue/projectCreator/fileupload', formData)
                .then(({ data: response }) => {
                    let filePath = response[0].filePath
                    if(filePath){
                        let data = {
                            ...userProfile,
                            image: filePath,
                        };
                        axiosInstance
                            .put('catalogue/projectCreator/userProfile/save', {
                                ...data,
                            })
                            .then((res) => {
                                dispatch(getUserProfile());
                                setImageFile(null)
                                setIsLoading(false)
                            })

                    }
                })
        }
        else {
            setIsLoading(true)
            const address = JSON.stringify({
                street: userProfile?.street,
                city: userProfile?.city,
                state: userProfile?.state,
                country: userProfile?.country,
                zip_code: userProfile?.zip_code,
            });
            const userProfileTemp = JSON.parse(JSON.stringify(userProfile))
            userProfileTemp.address = address
            setUserProfile({ ...userProfile, 'address': address });

            let data = userProfileTemp;
            axiosInstance
                .put('catalogue/projectCreator/userProfile/save', {
                    ...data,
                })
                .then((res) => {
                    dispatch(getUserProfile());
                    setImageFile(null)
                    setIsLoading(false)
                })
                .catch(e => {
                    setIsLoading(false)
                    notifyError({
                        title: 'Error',
                        message: e.message || e.toString(),
                    });
                });
        }
    };

    const cancelForm = () => {
        dispatch(getUserProfile());
        setImageFile(null)
        setIsLoading(true)
        setIsEditForm(false);
        setIsLoading(false)
    }

    const changePassword = (name: string, value: any) => {
        if (name) {
            if (name === 'passwordOld') {
                setPasswordOld(value);
            }
            else if(name === 'passwordNew'){
                setPasswordNew(value);
            }
        }
    };

    const submitPassword = () => {
        if(passwordNew && passwordOld){
            setIsLoading(true)
            let data = {
                "email":user.email,
                "oldPassword":passwordOld,
                "newPassword":passwordNew
            };
            axiosInstance
                .post('changePassword', {
                    ...data,
                })
                .then((res) => {
                    setPasswordOld('');
                    setPasswordNew('');
                    setIsLoading(false)
                })
                .catch(e => {
                    setIsLoading(false)
                    notifyError({
                        title: 'Error',
                        message: e.message || e.toString(),
                    });
                });
        }

    }

    return (
        <div className={css.module}>

            {
                isLoading ? (
                    <Loader className={css.loader}/>
                ) : (

                    <>

                        <Grid container spacing={1} className={css.avatarContainer}>

                            {
                                isEditForm ? (

                                    <>
                                        <div className={css.avatarDiv}>
                                            {imageFile ? (
                                                <Avatar alt={userProfile?.firstName} src={URL.createObjectURL(imageFile)} className={classNames(classes.large, css.customAvatar)} />
                                            ) : (
                                                <Avatar alt={userProfile?.firstName} src={userProfile?.image} className={classNames(classes.large, css.customAvatar)} />
                                            )}
                                            <div className={css.usernameContainer}>
                                                <input
                                                    type="file"
                                                    accept=".jpg, .jpeg, .png"
                                                    // ref={register}
                                                    name={AddContactFormNames.IMAGE}
                                                    id="file"
                                                    className={css.inputFile}
                                                    onChange={e => {
                                                        let files = e.target.files || '';
                                                        setImageFile(files[0]);
                                                    }}
                                                />
                                                <label htmlFor="file">Add Photo</label>
                                            </div>
                                        </div>


                                        <Grid item xs={12} className={css.avatarGrid}>
                                            <Grid container>

                                                <Grid item xs={9}>
                                                    <Paper square elevation={0} className={css.paperAddress}>
                                                        <Grid container>
                                                            <Grid item xs>
                                                                <Grid container>
                                                                    <Grid item xs={12}>
                                                                        <ProfileInput
                                                                            name='firstName'
                                                                            label='First Name'
                                                                            value={userProfile?.firstName}
                                                                            isPadding={false}
                                                                            elementFocus={elementFocus}
                                                                            updateData={updateData}
                                                                            isDisabled={false}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <ProfileInput
                                                                            name='lastName'
                                                                            label='Last Name'
                                                                            value={userProfile?.lastName}
                                                                            isPadding={false}
                                                                            elementFocus={elementFocus}
                                                                            updateData={updateData}
                                                                            isDisabled={false}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <ProfileInput
                                                                            name='email'
                                                                            label='Email'
                                                                            value={userProfile?.email}
                                                                            isPadding={false}
                                                                            elementFocus={elementFocus}
                                                                            updateData={updateData}
                                                                            isDisabled={true}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Typography className={classNames(css.bold, css.infoTitlePhone)}>Phone</Typography>

                                                                        <PhoneInput
                                                                            country={'us'}
                                                                            // country={countryCode.toLowerCase() || 'us'}
                                                                            value={userProfile?.telephone}
                                                                            containerStyle={{
                                                                                // margin: '1rem 0',
                                                                                // paddingRight: '20px'
                                                                            }}
                                                                            specialLabel={''}
                                                                            inputStyle={{
                                                                                width: '100%',
                                                                                borderRadius: '8px',
                                                                                backgroundColor: '#f3f3f3',
                                                                                fontSize: '14px',
                                                                                border: '1px solid #CACACA',
                                                                                padding: '16px 10px 16px 58px',
                                                                            }}
                                                                            onChange={e => updateData('telephone', e)}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Autocomplete
                                                                            options={dealAdvance}
                                                                            fullWidth
                                                                            value={userProfile?.currency}
                                                                            renderInput={(p: AutocompleteRenderInputParams) => (
                                                                                <TextFieldOutlined {...p} label="Currency" />
                                                                            )}
                                                                            onChange={(_, data) => updateData('currency', data)}
                                                                            className={css.inputCurrency}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs>
                                                                    <Grid container>
                                                                        <Grid item xs={12}>
                                                                            <ProfileInput
                                                                                name='street'
                                                                                label='Street'
                                                                                value={userProfile?.street}
                                                                                isPadding={true}
                                                                                elementFocus={elementFocus}
                                                                                updateData={updateData}
                                                                                isDisabled={false}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <ProfileInput
                                                                                name='city'
                                                                                label='City'
                                                                                value={userProfile?.city}
                                                                                isPadding={true}
                                                                                elementFocus={elementFocus}
                                                                                updateData={updateData}
                                                                                isDisabled={false}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <ProfileInput
                                                                                name='state'
                                                                                label='State/County'
                                                                                value={userProfile?.state}
                                                                                isPadding={true}
                                                                                elementFocus={elementFocus}
                                                                                updateData={updateData}
                                                                                isDisabled={false}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <ProfileInput
                                                                                name='country'
                                                                                label='Country'
                                                                                value={userProfile?.country}
                                                                                isPadding={true}
                                                                                elementFocus={elementFocus}
                                                                                updateData={updateData}
                                                                                isDisabled={false}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <ProfileInput
                                                                                name='zip_code'
                                                                                label='Zip Code'
                                                                                value={userProfile?.zip_code}
                                                                                isPadding={true}
                                                                                elementFocus={elementFocus}
                                                                                updateData={updateData}
                                                                                isDisabled={false}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <Button variant="contained" className={css.submitBtn} onClick={submitForm}>Submit</Button>
                                                                            <Button variant="contained" className={css.cancelBtn} onClick={cancelForm}>Cancel</Button>
                                                                        </Grid>
                                                                    </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>


                                                <Grid item xs={3}>
                                                    <Paper square elevation={0} className={css.paperAddress}>
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            <ProfileInput
                                                                name='passwordOld'
                                                                label='Old Password'
                                                                value={passwordOld}
                                                                isPadding={false}
                                                                elementFocus={elementFocus}
                                                                updateData={changePassword}
                                                                isDisabled={false}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <ProfileInput
                                                                name='passwordNew'
                                                                label='New Password'
                                                                value={passwordNew}
                                                                isPadding={false}
                                                                elementFocus={elementFocus}
                                                                updateData={changePassword}
                                                                isDisabled={false}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Button variant="contained" className={css.submitBtn} onClick={submitPassword}>Change</Button>
                                                        </Grid>
                                                    </Grid>
                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>

                                ) : (

                                    <>
                                        <div className={css.avatarDiv}>
                                            {imageFile ? (
                                                <Avatar alt={userProfile?.firstName} src={URL.createObjectURL(imageFile)} className={classNames(classes.large, css.customAvatar)} />
                                            ) : (
                                                <Avatar alt={userProfile?.firstName} src={userProfile?.image} className={classNames(classes.large, css.customAvatar)} />
                                            )}
                                            <div className={css.usernameContainer}>
                                                <Typography className={classNames(css.bold, css.username)}>{userProfile?.firstName}</Typography>
                                            </div>
                                        </div>

                                        <Grid item xs={12} className={css.avatarGrid}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>First Name</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.firstName}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>Last Name</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.lastName}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>Email</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.email}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>Phone</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.telephone}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>Currency</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.currency}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs>
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>Street</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.street}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>City</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.city}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>State/County</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.state}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>Country</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.country}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography className={classNames(css.bold, css.infoTitle)}>Zip Code</Typography>
                                                            <Typography className={classNames(css.infoContent)}>{userProfile?.zip_code}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>


                                            </Grid>
                                        </Grid>
                                    </>

                                )
                            }

                        </Grid>


                        <IconButton
                            className={classNames(css.editIcon)}
                            aria-label="add to favorites"
                            aria-owns={open ? 'mouse-over-popover' : undefined}
                            aria-haspopup="true"
                            onMouseEnter={handlePopoverOpen}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Popover
                            id="mouse-over-popover"
                            className={classes.popover}
                            classes={{
                                paper: classes.popoverContent,
                            }}
                            open={open}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                            PaperProps={{ onMouseLeave: handlePopoverClose }}
                        >
                            <List component="nav" className={classes.root} aria-label="contacts">
                                <ListItem button onClick={editContactForm}>
                                    <ListItemText primary="Edit" />
                                </ListItem>
                            </List>
                        </Popover>
                    </>

                )
            }

        </div>
    );
};
